import { useCopilotAction } from '@copilotkit/react-core'

import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

type F0MessageCreditsWarningProps = {
  actionHref?: string
}

const F0MessageCreditsWarning = ({ actionHref }: F0MessageCreditsWarningProps) => (
  <F0Alert
    title={i18n.t('common.ai.credit_warning.message_banner.title')}
    variant="warning"
    description={i18n.t('common.ai.credit_warning.message_banner.description')}
    action={
      actionHref
        ? {
            label: i18n.t('common.ai.credit_warning.message_banner.action_label'),
            onClick: () => {
              window.location.href = actionHref
            },
          }
        : undefined
    }
  />
)

/**
 * Renders an AI credits warning card with an optional action URL when the
 * company is running low on credits.
 */
export const useMessageCreditsWarningAction = () => {
  useCopilotAction({
    name: 'AiWidgets.UpsellKit.F0MessageCreditsWarning',
    description:
      'Display a warning card when the company has no AI credits left, with a call to action to get more credits.',
    parameters: [
      {
        name: 'actionHref',
        type: 'string',
        description: 'Optional URL opened when the action button is clicked',
        required: false,
      },
    ],
    available: 'frontend',
    render: ({ args: { actionHref } }) => <F0MessageCreditsWarning actionHref={actionHref} />,
  })
}
